// Original code adapted from Robert Kieffer.
// details at https://github.com/broofa/node-uuid
(function () {
  var _global = this;
  var mathRNG, whatwgRNG;

  // NOTE: Math.random() does not guarantee "cryptographic quality"
  mathRNG = function mathRNG(size) {
    var bytes = new Array(size);
    var r;
    for (var i = 0, r; i < size; i++) {
      if ((i & 0x03) == 0) r = Math.random() * 0x100000000;
      bytes[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }
    return bytes;
  };
  if (_global.crypto && crypto.getRandomValues) {
    whatwgRNG = function whatwgRNG(size) {
      var bytes = new Uint8Array(size);
      crypto.getRandomValues(bytes);
      return bytes;
    };
  }
  module.exports = whatwgRNG || mathRNG;
})();